import ParticipantsListView from './ParticipantsListView';
export default ParticipantsListView;
